import { useEffect, useMemo, useState } from 'react'
import { Accordion, AccordionSummary, AccordionDetails, Stack, Typography, Link, Box, Card, CardContent, } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { ReactComponent as AttachFileIcon } from '@assets/images/icon/ico_download.svg'
import { useIsMobile } from '@/hooks/Responsive'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SurveyImg from '@assets/images/sub/img_survey.svg';
import { getVLabLectureAttachFile, getVLabLectureSectionCourse } from '@/api/vx'
import { useAuth } from '@/components/AuthContext'
import { useParams } from 'react-router-dom'
import { downloadFile } from '@/api/util'



function formatContentTm(tm) {
  let seconds = Number(tm);
  if (seconds < 60) {
    	return '00:' + seconds
	}
	// sec
	var mins = Math.floor(seconds / 60);
	var secs = seconds - mins*60
	return addZero(mins) + ':' + addZero(secs)
    
	function addZero(num) {
		return ((num < 10) ? '0' : '') + num
	}
}

export default function LectureListTab() {
  const { isMobile } = useIsMobile()
  const { user } = useAuth();
  const [selected, setSelected] = useState(null)

  const { id } = useParams()
  const [allItems, setAllItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [attachFile, setAttachFile] = useState(null)

  function LectureAttachment() {
    
      if (!attachFile) return null;
    
      const ext = attachFile.lecturePlanFileName
        ?.split(".")
        .pop();
    
      const fileName = `강좌계획표.${ext}`;
    
      return (
        <Stack direction="row" justifyContent="flex-end">
    
          <Link
            component="button"
            underline="hover"
            onClick={() =>
              downloadFile(
                attachFile.lecturePlanFileUrl,
                fileName
              )
            }
            sx={{
              mt: 0,
              px: 2,
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
              cursor: "pointer"
            }}
          >
            <AttachFileIcon />
    
            <Typography component="span" color="text.primary">
              {fileName}
            </Typography>
    
          </Link>
    
        </Stack>
      );
    }

  useEffect(() => {
    const getLectureAttachFile = async () => {
          setLoading(true)
          try {
            const response = await getVLabLectureAttachFile({ params: { eduLectureId: id } })
            // The API doesn't exist, so I'll use the hardcoded data as a mock response.
            setAttachFile(response.data)
          } catch (error) {
            console.error('Failed to fetch lecture File:', error)
          } finally {
            setLoading(false)
          }
          
        }
    const getLectureList = async () => {
      setLoading(true)
      try {
        const response = await getVLabLectureSectionCourse({ params: { eduLectureId: id } })
        // The API doesn't exist, so I'll use the hardcoded data as a mock response.
        setAllItems(response.data)
      } catch (error) {
        console.error('Failed to fetch lecture list:', error)
      } finally {
        setLoading(false)
      }
    }
    getLectureAttachFile()
    getLectureList()
  }, [id])
  // const allItems = useMemo(() => ([
  //   // === 섹션01 ===
  //   { id: 'section-01', type: 'section', sectionNumber: '01', sectionTitle: '반도체 패키징 기초(2강)' },
  //   { id: 1010, no: 10, category: '일반형', title: '01강 반도체 패키징 공정', contentsType: '모바일 기기 실행', instructor: '홍길동', runningTime: '10:00' },
  //   { id: 1009, no: 9, category: '체험형', title: '02강 반도체 패키징 공정', contentsType: 'PC 기반 실행', instructor: '홍길동', runningTime: '10:00' },

  //   // === 섹션02 ===
  //   { id: 'section-02', type: 'section', sectionNumber: '02', sectionTitle: '패키징 공정 실습(2강)' },
  //   { id: 1008, no: 8, category: '일반형', title: '01강 패키징 실습 과정', contentsType: 'PC 기반 실행', instructor: '이민국', runningTime: '10:00' },
  //   { id: 1007, no: 7, category: '체험형', title: '02강 패키징 실습 과정', contentsType: '모바일 기기 실행', instructor: '이민국', runningTime: '10:00' },

  //   // === 섹션03 ===
  //   { id: 'section-03', type: 'section', sectionNumber: '03', sectionTitle: '고급 패키징 응용(2강)' },
  //   { id: 1006, no: 6, category: '일반형', title: '01강 고급 패키징 공정', contentsType: 'PC 기반 실행', instructor: '방통대', runningTime: '10:00' },
  //   { id: 1005, no: 5, category: '체험형', title: '02강 고급 패키징 공정', contentsType: '모바일 기기 실행', instructor: '방통대', runningTime: '10:00' },

  //   // === 설문 ===
  //   // { id: 'survey', type: 'survey', title: '강의 만족도 설문', period: '2025.11.01 ~ 2025.11.15' },
  // ]), [])

  const grouped = useMemo(() => {
    const result = []
    let currentSection = null

    allItems.forEach((item) => {
      // if (item.type === 'section') {
      if (item.sortSeq === '0') {
        currentSection = { ...item, lectures: [] }
        result.push(currentSection)
      } else if (item.type === 'survey') {
        if (result.length) result[result.length - 1].survey = item
      } else if (currentSection) {
        currentSection.lectures.push(item)
      }
    })
    return result
  }, [allItems])
  return (
    <>
      <LectureAttachment isMobile={isMobile} />

      {grouped.map((section, idx) => (
        <Box key={section.eduSectionId}>
          <Box
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 4,
              overflow: 'hidden',
              mt: 1.5,
            }}
          >
            <Accordion defaultExpanded={idx === 0} sx={{ boxShadow: 'none', '&:before': { display: 'none' }}}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  minHeight: 'auto',
                  p: 3,
                  '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
                    m: 0,
                  },
                }}
              >
                <Stack direction="row" alignItems="center">
                  <Typography fontWeight={500}>{String(idx+1).padStart(2,"0")}</Typography>
                  <Box
                    sx={{
                      width: '1px',
                      height: '16px',
                      bgcolor: 'divider',
                      mx: 1,
                    }}
                  />
                  <Typography>{section.eduSectionName}</Typography>
                </Stack>
              </AccordionSummary>

              <AccordionDetails sx={{ p: 0, px: isMobile ? 2 : 3 }}>
                {section.lectures.map((lec, idx) => (
                  <Stack
                    key={lec.eduCourseId}
                    direction={isMobile ? 'column' : 'row'}
                    justifyContent="space-between"
                    alignItems={isMobile ? 'flex-start' : 'center'}
                    sx={{
                      borderTop: '1px solid', 
                      borderColor: 'divider', 
                      p: 0,
                      py: 3
                    }}
                  >
                    <Stack spacing={1} sx={{ flex: 1, minWidth: 0 }}>
                      <Typography
                        color={
                          lec.contentsCategory === '체험형'
                            ? 'secondary2.main'
                            : 'secondary.main'
                        }
                        fontWeight={600}
                      >
                        {lec.lectureCategory}
                      </Typography>
                      <Typography variant="subtitle3" component="p" fontWeight={600}>
                        {lec.courseName ?? '제목 없음'}
                      </Typography>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant="body2" component="span" color="text.secondary">
                          {lec.lecturerName ?? '강사정보없음'}
                        </Typography>

                        <Box sx={{ width: '1px', height: '12px', bgcolor: 'divider' }} />

                        <Typography variant="body2" component="span" color="text.secondary">
                          {lec.contentType ?? 'PC 기반 실행'}
                        </Typography>

                        <Box sx={{ width: '1px', height: '12px', bgcolor: 'divider' }} />

                        <Stack direction="row" alignItems="center" spacing={0.5}>
                          <AccessTimeIcon fontSize="15" sx={{ color: 'text.secondary' }} />
                          <Typography variant="body2" component="span" color="text.secondary">
                            {lec?.contentTm ? formatContentTm(lec?.contentTm): '00:00'}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                ))}
              </AccordionDetails>
            </Accordion>
          </Box>
          
          <Box>
            {section.survey && (
              <Card variant="grey" sx={{ mt: 2 }}>
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    justifyContent: 'space-between',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    p: 3,
                    gap: isMobile ? 0 : 2,
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center">
                    {!isMobile && (
                      <Box
                        component="img"
                        src={SurveyImg}
                        alt="설문"
                        sx={{
                          width: '102px',
                          height: '64px',
                          objectFit: 'cover',
                        }}
                      />
                    )}
                    <Box>
                      <Typography variant="subtitle2" fontWeight={600}>
                        {section.survey.title}
                      </Typography>
                      <Typography>기간 {section.survey.period}</Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            )}
          </Box>

        </Box>
      ))}
    </>
  )
}
